import { useState } from 'react'
import { Button, Modal } from '../ui'

export const ModalLogin = ({
  open,
  close,
  login,
  forgotPassword,
  loading,
  loadingForgotPassword,
  onForgotSuccess,
}) => {
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [password, setPassword] = useState('')
  const [showForgot, setShowForgot] = useState(false)

  const handleForgotSuccess = () => {
    setShowForgot(false)
    setPhone('')
    setPassword('')
    onForgotSuccess?.()
  }

  const handlePhoneChange = e => {
    setPhone(e.target.value.replace(/[\s-]/g, ''))
  }

  return (
    <>
      <Modal
        isOpen={open}
        onClose={close}
        title={showForgot ? 'Recuperar Contraseña' : 'Iniciar sesión'}
      >
        {!showForgot ? (
          <>
            <div className="form-group">
              <label className="form-label">Correo electrónico *</label>
              <input
                className="form-input"
                type="email"
                onChange={e => setEmail(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label className="form-label">Contraseña *</label>
              <input
                className="form-input"
                type="password"
                onChange={e => setPassword(e.target.value)}
              />
            </div>
            <p style={{ fontSize: '0.875rem', marginTop: '0.5rem' }}>
              ¿Has olvidado tu contraseña?{' '}
              <span
                style={{ color: '#2440ab', cursor: 'pointer', fontWeight: 600 }}
                onClick={() => setShowForgot(true)}
              >
                Haz click aquí
              </span>
            </p>
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '0.5rem',
                marginTop: '1.5rem',
              }}
            >
              <Button variant="ghost" onClick={close}>
                Cerrar
              </Button>
              <Button
                variant="primary"
                onClick={() => login(email, password)}
                loading={loading}
              >
                Iniciar sesión
              </Button>
            </div>
          </>
        ) : (
          <>
            <div className="form-group">
              <label className="form-label">Correo electrónico *</label>
              <input
                className="form-input"
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value.replace(/[\s-]/g, ''))}
              />
            </div>
            <div className="form-group">
              <label className="form-label">Teléfono *</label>
              <p
                style={{
                  fontSize: '0.8rem',
                  color: '#999',
                  marginBottom: '0.25rem',
                }}
              >
                Introduce el teléfono que usaste para registrarte, sin espacios
                ni guiones
              </p>
              <input
                className="form-input"
                type="tel"
                placeholder="Ej: 699090907"
                value={phone}
                onChange={handlePhoneChange}
              />
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '0.5rem',
                marginTop: '1.5rem',
              }}
            >
              <Button variant="ghost" onClick={() => setShowForgot(false)}>
                Volver
              </Button>
              <Button
                variant="primary"
                onClick={() =>
                  forgotPassword(email, phone, handleForgotSuccess)
                }
                loading={loadingForgotPassword}
              >
                Recuperar contraseña
              </Button>
            </div>
          </>
        )}
      </Modal>
    </>
  )
}
